'use client'
import { useEffect, useState } from 'react'
import { create } from 'zustand'

import Shared from '@/shared'
import useHash from '@/shared/hooks/useHash'

import { SHEET_STATE_TYPE } from '@/enums/detail'
import { HASH_KEY_TYPE } from '@/enums/map'

interface MapLayoutState {
  positions: {
    paddingX: number
    bottomSheetYPosition: number
    buttonHeight: number
    currentLocationButtonEl: null | HTMLDivElement
  }
  setPaddingX: (paddingX: number) => void
  setButtonHeight: (buttonHeight: number) => void
  setBottomSheetYPosition: (bottomSheetYPosition: number) => void
  setCurrentLocationButtonEl: (currentLocationButtonEl: null | HTMLDivElement) => void
}

export const useMapLayoutPositions = create<MapLayoutState>((set) => ({
  positions: { paddingX: 16, buttonHeight: 42, currentLocationButtonEl: null, bottomSheetYPosition: 0 },

  setPaddingX: (paddingX: number) =>
    set((state) => ({
      positions: { ...state.positions, paddingX }
    })),

  setButtonHeight: (buttonHeight: number) =>
    set((state) => ({
      positions: { ...state.positions, buttonHeight }
    })),

  setBottomSheetYPosition: (bottomSheetYPosition: number) =>
    set((state) => ({
      positions: { ...state.positions, bottomSheetYPosition }
    })),

  setCurrentLocationButtonEl: (currentLocationButtonEl: null | HTMLDivElement) =>
    set((state) => ({
      positions: { ...state.positions, currentLocationButtonEl }
    }))
}))

const ticketPattern: RegExp = /\/t\/[0-9]+/
const myTicketPattern: RegExp = /\/my-ticket\/[0-9]+/

export const useFilterButtonYPosition = () => {
  if (ticketPattern.test(window.location.pathname)) {
    return 0
  } else if (myTicketPattern.test(window.location.pathname)) {
    return 0
  }
  return 137
}

export const useZoomControlYPosition = () => {
  const { positions } = useMapLayoutPositions()
  if (ticketPattern.test(window.location.pathname)) {
    return window.innerHeight / 2 - positions.buttonHeight
  } else if (myTicketPattern.test(window.location.pathname)) {
    return window.innerHeight / 2 - positions.buttonHeight
  }
  return window.innerHeight / 2
}

const WITH_BANNER_HEIGHT = 90
const WITHOUT_BANNER_HEIGHT = 16

export const useCurrentLocationButtonYPosition = () => {
  const { positions } = useMapLayoutPositions()
  const { isAirportBannerClosed } = Shared.States.useStorageStore()

  if (positions.bottomSheetYPosition === 0) {
    return isAirportBannerClosed ? WITHOUT_BANNER_HEIGHT : WITH_BANNER_HEIGHT
  }

  if (isAirportBannerClosed) {
    return window.innerHeight - positions.bottomSheetYPosition > WITHOUT_BANNER_HEIGHT
      ? window.innerHeight - positions.bottomSheetYPosition
      : WITHOUT_BANNER_HEIGHT
  } else {
    return window.innerHeight - positions.bottomSheetYPosition > WITH_BANNER_HEIGHT
      ? window.innerHeight - positions.bottomSheetYPosition
      : WITH_BANNER_HEIGHT
  }
}

export const useParkinglotLocationButtonYPosition = () => {
  const { positions } = useMapLayoutPositions()
  const currentLocationButtonYPosition = useCurrentLocationButtonYPosition()
  if (ticketPattern.test(window.location.pathname)) {
    return window.innerHeight - positions.bottomSheetYPosition + 68
  } else if (myTicketPattern.test(window.location.pathname)) {
    return window.innerHeight - positions.bottomSheetYPosition + 68
  }
  return (
    window.innerHeight -
    currentLocationButtonYPosition +
    (positions.buttonHeight + positions.paddingX) +
    positions.paddingX
  )
}
